module.exports = __webpack_public_path__ + "img/logo_fuchs.c54137c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_fuchs.svg
// module id = 5Umk
// module chunks = 1